(ns practitest.frontend.user-activity-log.subs
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-sub
 ::init-complete?
 (fn [db _]
   (get-in db [:user-activity-log :init-complete?])))

(re-frame/reg-sub
 ::get-all-entries
 (fn [db _]
   (get-in db [:user-activity-log :entries] [])))

(re-frame/reg-sub
 ::account-projects
 (fn [db _]
   (get-in db [:user-activity-log :account-projects] [])))
